import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const DashboardService = {
  actions: {
    fetchDashboardCounts ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/dashboard/counts',
          method: 'GET'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    }
  }
}

export default DashboardService



// WEBPACK FOOTER //
// ./src/services/dashboardService.js